import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Formik, Form } from "formik";
import { Grid, Paper } from "@mui/material";
import useJumboAuth from "@jumbo/hooks/useJumboAuth";
import { getSmartkioskInitialValues } from "app/pages/customers/dsok/utils/getSmartkioskInitialValues";
import SmartkioskCategories from "app/pages/customers/dsok/smartkioskFields/SmartkioskCategories";
import SmartkioskSettingsFields, {
  SETTINGS_FIELD_SCHEMA,
} from "app/pages/customers/dsok/smartkioskFields/SmartkioskSettingsFields";
import { DSOK_CUSTOMER_FIELD_SCHEMA } from "app/pages/customers/dsok/smartkioskFields/SmartkioskCustomerFields";
import DsokCustomerDetailLayout from "../components/DsokCustomerDetailLayout";
import DsokCustomerDetailDirtySync from "../components/DsokCustomerDetailDirtySync";
import DsokCustomerDetailSectionRegister from "../components/DsokCustomerDetailSectionRegister";
import { useDsokCustomerDetail } from "../data/useDsokCustomerDetail";

const CATEGORIES_FIELD_NAME = "CATEGORIES_FIELD";

const DsokCustomerCategoriesPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const auth = useJumboAuth();
  const authUser = auth?.getAuthUser?.() || {};
  const userTyp = authUser?.type ?? authUser?.typ ?? 1;
  const isAdmin = userTyp === 1;

  const { customer, customerUrl, hasEasyBuy } = useDsokCustomerDetail();
  const [expanded, setExpanded] = useState(CATEGORIES_FIELD_NAME);
  const handleChange = (panel) => (_event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const formInitialValues = useMemo(() => {
    if (!customer) {
      return {
        customer: { ...DSOK_CUSTOMER_FIELD_SCHEMA },
        settings: { ...SETTINGS_FIELD_SCHEMA },
      };
    }
    return getSmartkioskInitialValues(customer) ?? {
      customer: { ...DSOK_CUSTOMER_FIELD_SCHEMA },
      settings: { ...SETTINGS_FIELD_SCHEMA },
    };
  }, [customer]);

  useEffect(() => {
    if (!hasEasyBuy) {
      navigate(`/dsok/customer-detail/${customerUrl}`, { replace: true });
    }
  }, [hasEasyBuy, customerUrl, navigate]);

  if (!hasEasyBuy) {
    return null;
  }

  return (
    <DsokCustomerDetailLayout
      lastBreadcrumbLabel={t("dsokCustomerDetail.sections.categories.title")}
    >
      <Paper
        variant="outlined"
        sx={{
          bgcolor: "background.paper",
          p: 2,
          borderRadius: 1,
        }}
      >
        <Formik
          initialValues={formInitialValues}
          enableReinitialize
          onSubmit={() => {}}
        >
          <Form>
            <DsokCustomerDetailDirtySync />
            <DsokCustomerDetailSectionRegister
              sectionId="categories"
              getPayload={(values) =>
                values.settings?.smartkiosk?.categoriesDisplaySettings ?? {}
              }
            />
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <SmartkioskCategories
                  handleChange={handleChange}
                  expanded={expanded}
                  hideSectionTitle
                />
              </Grid>
            </Grid>
          </Form>
        </Formik>
      </Paper>
    </DsokCustomerDetailLayout>
  );
};

export default DsokCustomerCategoriesPage;
